"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheTimes = void 0;
/**
 * Cache Times In Milliseconds
 */
exports.CacheTimes = {
    TwentyFourHours: 86400000,
    OneHour: 3600000,
    FifteenMinutes: 900000
};
//# sourceMappingURL=cacheTimes.js.map